import React from 'react';
import ContactCard from '../components/ContactCard';
import Phone3D from '../components/Phone3D';
import './V2.css';

// Version 2 — iOS contact card experience.
//  - Mobile: the full-screen contact card.
//  - Desktop: a 3D phone (Three.js) floating in the star field, holding the card.
const V2 = () => (
  <div className="v2">
    <div className="v2-mobile">
      <ContactCard />
    </div>
    <div className="v2-desktop">
      <Phone3D />
    </div>
  </div>
);

export default V2;
